module.exports = __webpack_public_path__ + "img/entia-portafolio-infraestructura-carrusel-1.3eff333d.webp";